export default __webpack_public_path__ + "static/media/sd-paroksha-seva.438c00f8.png";